import posthog from 'posthog-js';

const posthogKey = import.meta.env.VITE_POSTHOG_KEY as string | undefined;
const posthogHost = import.meta.env.VITE_POSTHOG_HOST as string | undefined;

const isEnabled = Boolean(posthogKey && posthogHost);

if (!isEnabled) {
  console.warn(
    'PostHog analytics disabled: VITE_POSTHOG_KEY or VITE_POSTHOG_HOST is not configured',
  );
} else if (posthogKey && posthogHost) {
  posthog.init(posthogKey, { api_host: posthogHost });
}

export const posthogClient = {
  identify: (userId: string, props: { email: string }): void => {
    if (!isEnabled) {
      return;
    }
    posthog.identify(userId, props);
  },

  reset: (): void => {
    if (!isEnabled) {
      return;
    }
    posthog.reset();
  },

  capture: (event: string, props: Record<string, unknown>): void => {
    if (!isEnabled) {
      return;
    }
    posthog.capture(event, props);
  },
};
